import { hasText } from './dom';

const capitalizeFirstLetter = (str = ''): string => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

const getLabelText = (element: HTMLElement): string =>
  hasText(element) ? element.textContent : document.querySelector(`label[for="${element.id}"]`)?.textContent || '';

const guid = (): string =>
  [2, 1, 1, 1, 3]
    .map((count) => {
      let out = '';

      for (let i = 0; i < count; i++) {
        out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return out;
    })
    .join('-');

/**
 * Returns the value of the key from the object passed in. If the key does not exist on the object, an attempt to
 * retrieve the value from the fallback key is made, which is 'default' unless otherwise specified.
 */
const mapGet = (key: string, obj: Record<string, unknown>, fallback = 'default'): unknown =>
  obj[key] || obj[fallback] || undefined;

export { capitalizeFirstLetter, getLabelText, guid, mapGet };
